import React from "react"

const AlertComponent = (props) => {
  const [showAlert, setShowAlert] = React.useState(true)
  const onClick = () => setShowAlert(false)

  return (
    <button id="alert" className={`fixed bottom-5 right-5 ${!showAlert ? "hidden" : ""}`} onClick={onClick}>
      {props.type == "notice" ?
        <div className="rounded-md p-4 transition-colors duration-150 ease-in-out bg-green-50 hover:bg-green-100">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-green-800">
                {props.message}
              </p>
            </div>
          </div>
        </div>
        :
        <div className="rounded-md p-4 transition-colors duration-150 ease-in-out bg-red-50 hover:bg-red-100">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-red-800">
                {props.message}
              </p>
            </div>
          </div>
        </div>
      }
    </button>
  )
}


export default AlertComponent
